<template>
  <div
    class="relative base-textarea"
    :class="{error: hasErrors}"
  >
    <div class="flex between-xs">
      <label
        :class="{ disabled }"
        class="inline-block"
        :for="inputId"
      >
        <span class="inline-block">
          {{ label }}
        </span>
        <span
          v-if="required"
          class="c-primary inline-block"
        >*</span>
      </label>
      <validation-messages
        v-if="validations"
        :show-text="!hasFocus"
        :validations="validations"
      />
    </div>
    <div class="relative">
      <textarea
        :id="inputId"
        :ref="name"
        class="form-input"
        :class="{empty: value === ''}"
        :type="type"
        :name="name"
        :autocomplete="autocomplete"
        :value="value"
        :autofocus="autofocus"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :disabled="disabled"
        @input="$emit('input', $event.target.value)"
        @focus="onFocus"
        @blur="onBlur"
        @keyup.enter="$emit('keyup.enter', $event.target.value)"
        @keyup="$emit('keyup', $event)"
      />
    </div>
  </div>
</template>

<script>
import BaseInput from './BaseInput'

export default {
  name: 'BaseTextarea',
  mixins: [ BaseInput ]
}
</script>
